/* =========================================================
   PawHoodly — theme.js
   No dependencies. Everything degrades gracefully without JS.
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  /* ---------------- Mobile navigation drawer ---------------- */

  function initDrawer(root) {
    $$('[data-drawer]', root).forEach(function (drawer) {
      if (drawer.dataset.drawerReady === 'true') return;
      drawer.dataset.drawerReady = 'true';

      var id = drawer.getAttribute('data-drawer');
      var openers = $$('[data-drawer-open="' + id + '"]');
      var closers = $$('[data-drawer-close]', drawer);

      function open() {
        drawer.classList.add('is-open');
        document.body.classList.add('drawer-open');
        drawer.setAttribute('aria-hidden', 'false');
        var focusable = $('a, button', drawer);
        if (focusable) focusable.focus();
      }

      function close() {
        drawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (openers[0]) openers[0].focus();
      }

      openers.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          open();
        });
      });

      closers.forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  /* ---------------- Rotating announcements ---------------- */

  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar.dataset.announcementReady === 'true') return;
      bar.dataset.announcementReady = 'true';

      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;

      var speed = parseInt(bar.getAttribute('data-announcement-speed'), 10) || 5;
      var index = 0;

      setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speed * 1000);
    });
  }

  /* ---------------- Product media gallery ---------------- */

  function initGalleries(root) {
    $$('[data-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.galleryReady === 'true') return;
      gallery.dataset.galleryReady = 'true';

      var track = $('[data-gallery-track]', gallery);
      if (!track) return;

      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);

      function goTo(index, smooth) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: smooth === false || reduceMotion ? 'auto' : 'smooth'
        });
      }

      function setActive(index) {
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goTo(i);
          setActive(i);
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          setActive(i);
        });
      });

      $$('[data-gallery-arrow]', gallery).forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var direction = arrow.getAttribute('data-gallery-arrow') === 'next' ? 1 : -1;
          var current = currentIndex();
          var next = Math.min(Math.max(current + direction, 0), slides.length - 1);
          goTo(next);
          setActive(next);
        });
      });

      function currentIndex() {
        var closest = 0;
        var min = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < min) {
            min = distance;
            closest = i;
          }
        });
        return closest;
      }

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActive(currentIndex());
        }, 80);
      }, { passive: true });

      gallery.selectMedia = function (mediaId) {
        var index = slides.findIndex(function (slide) {
          return slide.getAttribute('data-media-id') === String(mediaId);
        });
        if (index > -1) {
          goTo(index);
          setActive(index);
        }
      };

      setActive(0);
    });
  }

  /* ---------------- Quantity selectors ---------------- */

  function initQuantity(root) {
    $$('[data-quantity]', root).forEach(function (wrapper) {
      if (wrapper.dataset.quantityReady === 'true') return;
      wrapper.dataset.quantityReady = 'true';

      var input = $('input', wrapper);
      if (!input) return;

      $$('[data-quantity-change]', wrapper).forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.getAttribute('data-quantity-change'), 10);
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var value = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, value);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Variant picker ---------------- */

  function initVariants(root) {
    $$('[data-variant-picker]', root).forEach(function (picker) {
      if (picker.dataset.variantReady === 'true') return;
      picker.dataset.variantReady = 'true';

      var sectionId = picker.getAttribute('data-section');
      var scope = document.getElementById('shopify-section-' + sectionId) || document;
      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      var productUrl = picker.getAttribute('data-url');
      var inputs = $$('input[type="radio"]', picker);
      var selects = $$('select[data-option-position]', picker);

      function selectedOptions() {
        var values = [];
        selects.forEach(function (select) {
          values[parseInt(select.getAttribute('data-option-position'), 10) - 1] = select.value;
        });
        inputs.forEach(function (input) {
          if (input.checked) {
            values[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
          }
        });
        return values;
      }

      function findVariant(values) {
        return variants.filter(function (variant) {
          return variant.options.every(function (option, index) {
            return option === values[index];
          });
        })[0];
      }

      function markAvailability(values) {
        inputs.forEach(function (input) {
          var position = parseInt(input.getAttribute('data-option-position'), 10) - 1;
          var candidate = values.slice();
          candidate[position] = input.value;
          var match = findVariant(candidate);
          var label = picker.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      function updateLabels() {
        $$('[data-option-selected]', picker).forEach(function (element) {
          var position = parseInt(element.getAttribute('data-option-selected'), 10) - 1;
          element.textContent = selectedOptions()[position] || '';
        });
      }

      function update() {
        var values = selectedOptions();
        var variant = findVariant(values);

        markAvailability(values);
        updateLabels();

        var idInput = $('[data-variant-id]', scope);
        var priceCurrent = $$('[data-price-current]', scope);
        var priceCompare = $$('[data-price-compare]', scope);
        var priceBadge = $$('[data-price-badge]', scope);
        var addButtons = $$('[data-atc-button]', scope);
        var addText = $$('[data-atc-text]', scope);
        var paymentButton = $('.shopify-payment-button', scope);

        if (!variant) {
          addButtons.forEach(function (button) { button.disabled = true; });
          addText.forEach(function (element) {
            element.textContent = element.getAttribute('data-unavailable-text') || 'Unavailable';
          });
          return;
        }

        if (idInput) idInput.value = variant.id;

        priceCurrent.forEach(function (element) { element.innerHTML = variant.price; });

        priceCompare.forEach(function (element) {
          if (variant.compare_at_price) {
            element.innerHTML = variant.compare_at_price;
            element.hidden = false;
          } else {
            element.hidden = true;
          }
        });

        priceBadge.forEach(function (element) {
          if (variant.discount) {
            element.textContent = '-' + variant.discount + '%';
            element.hidden = false;
          } else {
            element.hidden = true;
          }
        });

        addButtons.forEach(function (button) { button.disabled = !variant.available; });
        addText.forEach(function (element) {
          element.textContent = variant.available
            ? element.getAttribute('data-add-text') || 'Add to cart'
            : element.getAttribute('data-soldout-text') || 'Sold out';
        });

        if (paymentButton) paymentButton.style.display = variant.available ? '' : 'none';

        var gallery = $('[data-gallery]', scope);
        if (gallery && gallery.selectMedia && variant.media_id) gallery.selectMedia(variant.media_id);

        if (productUrl && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
        }
      }

      inputs.forEach(function (input) { input.addEventListener('change', update); });
      selects.forEach(function (select) { select.addEventListener('change', update); });

      update();
    });
  }

  /* ---------------- Sticky add to cart ---------------- */

  function initStickyAtc(root) {
    $$('[data-sticky-atc]', root).forEach(function (bar) {
      if (bar.dataset.stickyReady === 'true') return;
      bar.dataset.stickyReady = 'true';

      var anchor = document.querySelector('[data-atc-anchor]');
      if (!anchor || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -100% 0px', threshold: 0 });

      observer.observe(anchor);
    });
  }

  /* ---------------- Video play buttons ---------------- */

  function initVideos(root) {
    $$('[data-video-play]', root).forEach(function (button) {
      if (button.dataset.videoReady === 'true') return;
      button.dataset.videoReady = 'true';

      button.addEventListener('click', function () {
        var wrapper = button.closest('[data-video-wrapper]');
        if (!wrapper) return;

        var video = $('video', wrapper);
        var iframe = $('iframe[data-src]', wrapper);
        var poster = $('[data-video-poster]', wrapper);

        if (video) {
          video.setAttribute('controls', 'controls');
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else if (iframe) {
          iframe.setAttribute('src', iframe.getAttribute('data-src'));
        }

        if (poster) poster.remove();
        button.remove();
      });
    });
  }

  /* ---------------- Scroll reveal ---------------- */

  function initReveal(root) {
    if (!document.body.classList.contains('animations-enabled') || reduceMotion) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    $$('[data-reveal]', root).forEach(function (element) {
      if (element.dataset.revealReady === 'true') return;
      element.dataset.revealReady = 'true';
      observer.observe(element);
    });
  }

  /* ---------------- Cart quantity auto update ---------------- */

  function initCart(root) {
    $$('.cart-form', root).forEach(function (form) {
      if (form.dataset.cartReady === 'true') return;
      form.dataset.cartReady = 'true';

      var updateButton = $('[data-cart-update]', form);
      if (updateButton) updateButton.hidden = true;

      $$('input[name^="updates"]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          if (updateButton) {
            updateButton.click();
          } else {
            form.submit();
          }
        });
      });
    });
  }

  /* ---------------- Newsletter inline feedback ---------------- */

  function initForms(root) {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    $$('[data-newsletter-success]', root).forEach(function (element) {
      element.hidden = false;
    });
  }

  /* ---------------- Boot ---------------- */

  function init(root) {
    initDrawer(root);
    initAnnouncement(root);
    initGalleries(root);
    initQuantity(root);
    initVariants(root);
    initStickyAtc(root);
    initVideos(root);
    initReveal(root);
    initCart(root);
    initForms(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
})();
